import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { MESSAGES } from '@utils/constants';
import { NotificationService } from '../services/notification.service';
import { UserStateService } from '../services/state/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class TeacherHasAcceptedAgreementGuard {
  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private userStateService: UserStateService,
  ) {}

  public canActivate(): Observable<boolean | UrlTree> {
    return this.userStateService.checkUserPermissions().pipe(
      take(1),
      map((checkPermission) => {
        return true;
        // if (checkPermission.hasAcceptedTeacherAgreement) {
        //   return true;
        // } else {
        //   return this.navigateOnFailure();
        // }
      }),
    );
  }

  public canActivateChild(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }

  private navigateOnFailure(): UrlTree {
    const message = MESSAGES.guard.notAcceptedAgreements;
    this.notificationService.showError([message]);

    return this.router.parseUrl('/');
  }
}
